module.exports = __webpack_public_path__ + "static/jayjay-14ab1b5f4e1c1a6d87ceed77315c8875.webp";